import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HTTPService, HelperService, FormatService } from 'app/services';
import { config } from 'app/constants';

@Component({
  selector: 'app-customer-inspections',
  templateUrl: './customer-inspections.component.html',
  styleUrls: ['./customer-inspections.component.scss'],
})
export class CustomerInspectionsComponent implements OnInit {
  @Input('appts')
  set appts(data: any) {
    if (data) {
      this.customerAppointments = data;
    }
  }
  @Input('customerData')
  set customerData(data: any) {
    if (data && Object.keys(data).length > 0) {
      this.customer = data;
      const conf = {
        customerId: this.customer._id,
        limit: config.inspectionPageSize,
        offset: 0,
        sort: 'createdAt',
        order: -1,
      };
      this.customerInspections = [];
      this.fetchCustomerInspections(conf);
    }
  }
  @Input() vehicles: any[] = [];
  @Input() isLoadingAppointment: boolean = false;
  @Input() isMultiLocationEnabled: boolean = false;
  @Input() shopsMap: any = {};
  @Input() user: any = {};

  customer: any;
  customerInspections = [];
  inspectionCategories: any;
  green: any = 0;
  yellow: any = 0;
  red: any = 0;
  showInspections: any = config.inspectionPageSize;
  customerAppointments: any;
  inspectionsSkip: number = 0;

  constructor(private httpService: HTTPService, private formatService: FormatService, private helperService: HelperService) {}

  ngOnInit() {}

  fetchCustomerInspections(details: any) {
    this.httpService.getCustomerInspections(details).then(
      (result) => {
        const formattedInspections = this.formatService.customerInspectionsFormat(result);
        this.customerInspections.push(...formattedInspections);
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  preview(order: any) {
    const estimateId = typeof order.estimate === 'string' ? order?.estimate : order.estimate?._id;
  
    if (estimateId) {
      this.helperService.openPageInNewTab(`/customer-review/inspection/${estimateId}`);
    }
  }

  showAll() {
    this.inspectionsSkip += config.inspectionPageSize;
    const conf = {
      customerId: this.customer._id,
      limit: config.inspectionPageSize,
      offset: this.inspectionsSkip,
      sort: 'createdAt',
      order: -1,
    };
    this.fetchCustomerInspections(conf);
    this.showInspections = this.customerInspections.length;
    event.stopPropagation();
  }
}
